import React from 'react'
import { Link } from 'gatsby'
import { Hero, HeroInner } from '../containers/Header'
import { DesktopMenu, MobileMenu } from './Menu'

const Header = (props) => {
  return (
    <React.Fragment>
      <Hero>
        <MobileMenu {...props} />
        <HeroInner>
          <p className="h1">
            <Link to="/"><span>Remy</span> Disch</Link>
            <small>Réalisateur</small>
          </p>
          <DesktopMenu {...props} />
        </HeroInner>
      </Hero>
    </React.Fragment>
  )
}

export default Header;